// src/routes/(app)/(platform)/(videos)/videos/+page.ts
import type { PageLoad } from './$types';
import { getPage } from '$lib/services/page';

export const load: PageLoad = async ({ parent }) => {
	const { balancedSupabase } = await parent();

	const [page] = await Promise.all([
		getPage(balancedSupabase, '67f515c3-ac69-479f-a543-87555e97b25f')
	]);

	return {
		page
	};
};
